var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"loading-container"},[_c('img',{staticClass:"img-fluid bg-img",attrs:{"src":require("@/assets/images/ajax-loader.gif")}})])}
var staticRenderFns = []

export { render, staticRenderFns }